import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Quest/Resources/Domain/commands-core';
import { Component } from 'vue-facing-decorator';

@Component
export default class ResourcesCommands extends VueCqrs {

	invokeCreateResourceCommandV1(workspaceId: number, strategyId: string, resourceId: string, name: string, unit: string, expenseClassification: string, costPerUnit: number)
	{
		const cmd = new c.CreateResourceCommandV1(workspaceId, strategyId, resourceId, name, unit, expenseClassification, costPerUnit);
		this.$command(cmd, resourceId);
	}

	invokeUpdateResourceCommandV1(workspaceId: number, strategyId: string, resourceId: string, name: string, unit: string, expenseClassification: string)
	{
		const cmd = new c.UpdateResourceCommandV1(workspaceId, strategyId, resourceId, name, unit, expenseClassification);
		this.$command(cmd, resourceId);
	}

	invokeDeleteResourceCommandV1(workspaceId: number, strategyId: string, resourceId: string)
	{
		const cmd = new c.DeleteResourceCommandV1(workspaceId, strategyId, resourceId);
		this.$command(cmd, resourceId);
	}

	invokeUpdateResourceCapacitiesCommandV1(workspaceId: number, strategyId: string, resourceId: string, entries: string[])
	{
		const cmd = new c.UpdateResourceCapacitiesCommandV1(workspaceId, strategyId, resourceId, entries);
		this.$command(cmd, resourceId);
	}
}
